<script>
export default {
    name: 'SearchSuggestionsList',
    inject: ['$t'],
    props: {
        searchString: {
            type: String,
            required: true
        },
        suggestions: {
            type: Array,
            required: true
        }
    },
    methods: {
        getSearchUrl(query) {
            return `${window.BASE_URL}catalogsearch/result/?q=${query}`;
        },
        highlightSearchString(content) {
            const reg = new RegExp(this.searchString, 'gi');

            return content.replace(reg, function (str) {
                return '<strong>' + str + '</strong>';
            });
        }
    }
};
</script>

<template>
    <div class="border-main-dark-transparent-15 border-y pt-6 pb-10">
        <div class="text-lg-v3 mb-8 font-bold">
            <div class="text-md-v4 mb-4 font-bold">
                {{ $t('resultTitle') }}
            </div>
        </div>
        <div v-if="suggestions.length">
            <ul class="flex grid-cols-3 flex-col gap-4 lg:grid">
                <li v-for="(item, key) in suggestions" :key="key">
                    <a :href="getSearchUrl(item.title)" class="text-base-v2">
                        <span v-html="highlightSearchString(item.title)"></span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
